import React, { useState } from 'react';
import { staffLogin, API_BASE_URL } from '../utils/api';
import { useResponsive } from '../hooks/useResponsive';

const Login = ({ onLogin }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { isMobile } = useResponsive();

  const handlePin = (digit) => {
    if (pin.length < 4) {
      const newPin = pin + digit;
      setPin(newPin);
      if (newPin.length === 4) handleLogin(newPin);
    }
  };

  const handleLogin = async (enteredPin) => {
    setLoading(true);
    setError('');
    try {
      const res = await staffLogin(enteredPin);
      onLogin(res);
    } catch (err) {
      setError('Invalid PIN. Please try again.');
      setPin('');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => { setPin(''); setError(''); };

  const buttons = ['1','2','3','4','5','6','7','8','9','','0','⌫'];

  return (
    <div style={{
      minHeight: '100dvh',
      background: '#0D0D0D',
      display: 'flex',
      alignItems: isMobile ? 'flex-start' : 'center',
      justifyContent: 'center',
      fontFamily: "'Georgia', serif",
      padding: isMobile ? '24px 16px' : '24px',
      boxSizing: 'border-box',
      overflowY: 'auto',
    }}>
      <div style={{
        background: '#1A1A1A',
        borderRadius: 16,
        // Responsive padding — smaller on mobile
        padding: isMobile ? '28px 24px' : '48px',
        // Responsive width — fills mobile screen
        width: isMobile ? '100%' : 340,
        maxWidth: 380,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: '1px solid #2A2A2A',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        boxSizing: 'border-box',
      }}>
        {/* Wordmark */}
        <div style={{ textAlign: 'center', marginBottom: isMobile ? 24 : 40 }}>
          <img
            src={process.env.REACT_APP_LOUNGE_LOGO}
            alt="Lounge logo"
            style={{ width: 120, height: 'auto', display: 'block', margin: '0 auto 16px auto' }}
          />
          <p style={{ color: '#666', fontSize: 12, letterSpacing: 3, marginTop: 6, textTransform: 'uppercase' }}>
            Point of Sale
          </p>
        </div>

        {/* PIN dots */}
        <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
          {[0,1,2,3].map(i => (
            <div key={i} style={{
              width: 16, height: 16, borderRadius: '50%',
              border: '2px solid #C9A84C',
              background: pin.length > i ? '#C9A84C' : 'transparent',
              transition: 'background 0.15s',
            }} />
          ))}
        </div>

        {error && (
          <p style={{ color: '#E74C3C', fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
            {error}
          </p>
        )}

        {/* Keypad */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: isMobile ? 8 : 12,
          width: '100%',
          marginBottom: isMobile ? 16 : 24,
        }}>
          {buttons.map((btn, i) => (
            <button
              key={i}
              style={{
                background: '#2A2A2A',
                border: '1px solid #333',
                borderRadius: 10,
                color: '#FFF',
                fontSize: isMobile ? 20 : 22,
                fontFamily: "'Georgia', serif",
                // Taller keys on mobile for easier tapping
                height: isMobile ? 64 : 'auto',
                padding: isMobile ? '0' : '18px 0',
                cursor: btn === '' ? 'default' : 'pointer',
                opacity: btn === '' ? 0 : 1,
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // Active press feedback
                transition: 'opacity 0.1s',
              }}
              onPointerDown={(e) => {
                e.preventDefault();
                if (btn === '⌫') handleClear();
                else if (btn !== '') handlePin(btn);
              }}
              disabled={loading || btn === ''}
            >
              {btn}
            </button>
          ))}
        </div>

        <p style={{ color: '#444', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>
          Enter your 4-digit PIN
        </p>

        {/* Puro POS branding — shown inside card on mobile only */}
        <img
          src={`${API_BASE_URL}/images/puroai-logo.png`}
          alt="Powered by Puro POS"
          style={{ height: 100, width: 'auto', opacity: 0.7, marginTop: 20 }}
        />

      </div>
    </div>
  );
};

export default Login;
